import { addCollection } from '@iconify/vue'
import { createInertiaApp } from '@inertiajs/vue3'
import ui from '@nuxt/ui/vue-plugin'
import { centralicons } from '~/assets/icons/centralicons/line/centralicons'
import AppLayout from '~/layouts/AppLayout.vue'

addCollection(centralicons)

createInertiaApp({
  title: (title) => (title ? `${title} - Milkstraw AI` : 'Milkstraw AI'),
  progress: false,
  pages: '../pages',
  layout: () => AppLayout,

  withApp(app) {
    app.use(ui)
  }
}).catch(console.error)
